module.exports = __webpack_public_path__ + "assets/img/news2.1.9c8d7da4.png";